export default __webpack_public_path__ + "static/media/Mask Group.4fae966e.png";